import { fetchWithAuth, urlBuilder } from "@/lib/api/utils";
import { Config } from "@/lib/api/types";

export async function fetchConfig(): Promise<Config> {
  return fetchWithAuth(urlBuilder("/config")).then((res) => res.json());
}
